import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { db } from './firebase';
import { collection, getDocs } from 'firebase/firestore';
import MenuIcon from '@mui/icons-material/Menu';
import './SubHeader.css';

function SubHeader() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  // Legge la categoria attualmente selezionata dall'URL (es. ?category=Utensileria)
  const queryParams = new URLSearchParams(location.search);
  const activeCategory = queryParams.get('category') || 'all';

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const prodottiRef = collection(db, 'prodotti');
        const snapshot = await getDocs(prodottiRef);

        // Estrae tutte le tipologie dai prodotti e rimuove i valori nulli o vuoti
        const allTipologie = snapshot.docs
          .map(doc => doc.data().tipologia)
          .filter(Boolean);

        // Rimuove i duplicati creando una lista unica di categorie
        const uniqueCategories = [...new Set(allTipologie)].sort();

        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Errore nel recupero delle categorie:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCategoryClick = (categoryName) => {
    if (categoryName === 'all') {
      navigate('/search');
    } else {
      // Naviga verso la pagina search passando il parametro category
      navigate(`/search?category=${encodeURIComponent(categoryName)}`);
    }
  };

  return (
    <div className="subheader">
      {/* Tasto fisso "Tutti i prodotti" */}
      <div 
        className={`subheader_item subheader_all ${activeCategory === 'all' ? 'active' : ''}`}
        onClick={() => handleCategoryClick('all')}
      >
        <MenuIcon className="subheader_menuIcon" />
        <span>Tutte le categorie</span>
      </div>

      {/* Categorie dinamiche lette dal DB */}
      <div className="subheader_categories">
        {loading ? (
          <span className="subheader_loading">Caricamento categorie...</span>
        ) : (
          categories.map((cat) => (
            <div
              key={cat}
              className={`subheader_item ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => handleCategoryClick(cat)}
            >
              {cat}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default SubHeader;